import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicNotSetupPartners({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-10.9%"
          y="-7.8%"
          width="121.9%"
          height="121.9%"
          filterUnits="objectBoundingBox"
          id="pic-not-setup-partners_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <circle id="pic-not-setup-partners_svg__b" cx={32} cy={32} r={32} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M168.282 136c-43.349 0-57.183 12-92.208 12C46 148 6.422 139.341 15 97.941 23.025 59.21 55.229 47.5 90.85 21c108.234-80.52 198.122 115 77.432 115z"
          fill="#FFE6CE"
        />
        <path
          d="M168.282 136c-44.201-1.04-46.372 12-97.861 11-29.637 0-54.86-9.876-56.612-36-.81-34.35 65.401-7.856 92.65-23.524 56.38-32.419 112.987 28.478 103.327 36.357-9.66 7.878-24.975 12.556-41.504 12.167z"
          fill="#FB8F23"
          opacity={0.16}
        />
        <path
          d="M171.6 107.42a8 8 0 11-4.141 15.456 8 8 0 014.141-15.455zm12.941-48.296a8 8 0 015.444 10.473l-8.65 27.357-.031-.008a6.667 6.667 0 11-12.726-3.98l6.002-27.437a8 8 0 019.961-6.405z"
          fill="#FCC083"
        />
        <g transform="matrix(-1 0 0 1 157.601 42.64)">
          <path
            d="M34.442 20.316v.003l-3.013 2.518-20.72 4.603a5.238 5.238 0 103.928 9.712l13.197-2.222a16.193 16.193 0 002.161-.513c.278-.083.553-.177.824-.275a84.296 84.296 0 014.92-14.907l-1.297 1.08z"
            fill="#F9FAFA"
          />
          <path
            d="M29.123 65.03c2.545 8.168 4.39 19.37 5.535 33.606-5.97-1.55-9.556-2.154-13.862-2.825l-1.743-10.38a.1.1 0 00-.199.012l-.471 9.908a272.467 272.467 0 00-12.079-1.343c.093-3.002.232-10.013.42-21.03l22.4-7.949z"
            fill="#8E9FCC"
          />
          <circle fill="#F89D96" cx={11.872} cy={12.216} r={8.874} />
          <path
            d="M4.917 73.7c2.167 5.058 11.561 8.671 13.729 1.445 1.676-5.585 8.317-7.933 11.247-8.71a1.451 1.451 0 001.033-1.756l-8.19-32.173a11.298 11.298 0 00-7.61-8.006C8.617 22.484 1.753 26.635.65 33.359a49.553 49.553 0 00-.575 5.694C-.604 53.248 3.49 70.369 4.917 73.7z"
            fill="#F9FAFA"
          />
          <path
            d="M54.204 44.716a3.633 3.633 0 00-5.37 1.481L35.98 44.985l3.152 5.923 11.723.243a3.653 3.653 0 003.35-6.435z"
            fill="#F89D96"
          />
          <path
            d="M47.812 51.303c-.309.344-.749.54-1.21.54l-16.779-.384a16.754 16.754 0 01-11.036-4.16l-10.06-8.823a5.237 5.237 0 115.042-9.181L30.43 42.443l16.223 3.126a1.631 1.631 0 011.232 1.404l.333 3.068a1.628 1.628 0 01-.407 1.262z"
            fill="#F9FAFA"
          />
          <path
            d="M5.137 19.474a1.448 1.448 0 002.133-.856l.005-.02c.16-.674.027-1.377-.02-2.068-.046-.69.022-1.45.493-1.958.877-.947 2.437-.445 3.706-.684a3.13 3.13 0 002.435-3.343 4.752 4.752 0 00-.078-.431 2.41 2.41 0 012.502-2.92c1.282.073 2.666.462 3.727-.488a2.749 2.749 0 00.66-2.963c-.606-1.748-2.318-2.663-4.012-3.166A14.676 14.676 0 004.25 2.617c-1.07.755-2.069 1.703-2.525 2.93-.456 1.226-.236 2.774.792 3.584a6.623 6.623 0 00-1.534 6.434c.508 1.636 2.932 3.205 4.155 3.909z"
            fill="#333532"
          />
        </g>
        <path
          d="M121.986 34.268a8.75 8.75 0 01.7 15.637l7.309 3.254a6 6 0 013.04 7.921l-6.507 14.617c-4.493 10.09-16.315 14.629-26.406 10.136L81.852 77.7a2 2 0 01-1.014-2.641l4.88-10.962a8.75 8.75 0 115.694-12.79l4.068-9.136a4 4 0 015.281-2.027l9.135 4.068a8.75 8.75 0 0112.09-9.943z"
          fill="#999"
        />
        <g transform="translate(42 100)">
          <use
            fill="#000"
            filter="url(#pic-not-setup-partners_svg__a)"
            xlinkHref="#pic-not-setup-partners_svg__b"
          />
          <circle fill="#FFF" cx={32} cy={32} r={32} />
        </g>
        <g fill="#FB8F23">
          <path d="M90.715 121.453L86.7 125.48l-3.914-.71-.703-3.913 4.013-4.027c-.902-.901-2.188-1.313-3.14-1.263-.958.05-3.004.589-4.589 2.272-1.534 1.619-3.147 4.637-1.719 7.989.17.404.363.937-.206 1.505-.575.568-17.196 16.341-17.196 16.341-1.378 1.186-1.278 3.38-.007 4.658 1.293 1.271 3.474 1.35 4.66-.02 0 0 15.648-16.555 16.323-17.215.603-.59 1.143-.391 1.506-.206 2.528 1.306 6.13.17 7.999-1.698 1.868-1.867 2.209-3.67 2.266-4.594.057-.916-.263-2.13-1.28-3.146zm-28.25 25.253a1.15 1.15 0 01-1.612 0 1.149 1.149 0 010-1.612 1.15 1.15 0 011.613 0c.44.448.44 1.172 0 1.612z" />
          <path d="M72.243 129.466l-2.543 2.46-5.305-5.27-1.27 1.233-7.125-6.9 5.088-4.93 7.123 6.9-1.274 1.234 5.306 5.273zm16.453 17.349l-2.035 1.973c-1.406 1.361-3.681 1.361-5.087 0 0 0-8.153-8.251-8.035-7.96 3-5.056 7.362-6.204 7.362-6.204l7.795 7.263a3.406 3.406 0 010 4.928zm-12.099-6.962a.858.858 0 000 1.238l6.542 6.336a.92.92 0 001.277 0 .855.855 0 000-1.236l-6.541-6.339a.92.92 0 00-1.278 0zm10.695 3.547l-6.537-6.336a.923.923 0 00-1.28 0 .855.855 0 000 1.236l6.541 6.339c.352.34.924.34 1.276 0a.856.856 0 000-1.238z" />
        </g>
      </g>
    </svg>
  );
}

SvgPicNotSetupPartners.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicNotSetupPartners.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicNotSetupPartners svgRef={ref} {...props} />
));
export default ForwardRef;
